function GenesProteinClass() {
  return (
    <div>
      <li className="bullet-item">
        The protein class is obtained from the top level category from the{' '}
        <a className="tt" target="_blank" rel="noreferrer" href="http://drugtargetontology.org/">
          Chemical Target Ontology
        </a>
        .
      </li>
    </div>
  );
}

export default GenesProteinClass;
